import React, { Component } from 'react'
import queryString from 'query-string'
import _ from 'lodash'
import history from '../history'
import CommonModal from '../Modals/common'
import { Days } from '../../constants/common'
import { defaultSchedule } from '../../constants/common'
import './styles.scss'

const { home1, home2, away, sleep } = defaultSchedule

class CopySelectedSchedule extends Component {
  constructor() {
    super()
    this.state = {
      schedules: [],
      room: {},
      roomId: 0,
      dayOfWeek: 1, // default value
      showFirstTime: false,
      disabled: true,
      copied: false
    }
    this.closeModal = this.closeModal.bind(this)
    this.setScheduleCall = this.setScheduleCall.bind(this)
    this.next = this.next.bind(this)
  }

  componentWillMount() {
    this.props.clearCozyProps()
    const { fetchRooms, location } = this.props
    // Fetch rooms initially once component loaded
    fetchRooms()
    const dayOfWeek = _.get(queryString.parse(location.search), 'dayOfWeek', 1)
    let roomId = _.get(queryString.parse(location.search), 'roomId', 0)
    if (roomId === 0) { // pick from cache if roomId is zero and this cache is set from home or barcode page
      roomId = localStorage.getItem('room') ? localStorage.getItem('room') : 0
    }
    this.setState({ dayOfWeek, roomId })
  }

  componentWillReceiveProps(np) {
    const { rooms, setScheduleSuccess } = np
    if (rooms) {
      const room = _.filter(rooms, o => {
        return parseInt(o.id, 10) === parseInt(this.state.roomId, 10)
      })
      if (room) {
        this.setState({ room: _.get(room, '[0]', {}) })
      }
    }
    /* Handle multiple update oprations for schedule when props return successful save for one and then process other
    */
    if (setScheduleSuccess) {
      const schedules = _.cloneDeep(this.state.schedules)
      schedules.splice(0, 1)
      this.setState({ schedules }, () => {
        if (!_.size(schedules)) { // 0 length of array
          this.setState({ copied: true })
        } else {
          // Call setScheduleCall() function on success of all the update operations
          this.setScheduleCall()
        }
      })
    }
  }

  componentWillUnmount() {
    // Reset values to default on component unmount
    this.setState({ copied: false, showFirstTime: false })
  }

  onClickDayOfWeek(i) {
    const { room } = this.state // room always available
    const schedules = this.state.schedules
    // Get the index of current checked day
    const index = schedules.map((schedule) => { return schedule.dayOfWeek }).indexOf(i)
    // Find the current dayOfWeek index so called dayIndex
    const schedulesRoom = _.get(room, 'schedules', [])
    const dayIndex = schedulesRoom.map((schedule) => { return schedule.dayOfWeek }).indexOf(parseInt(this.state.dayOfWeek, 10))
    // If no schedule is available in state schedules array then push
    if (index === -1) {
      schedules.push({
        away: _.get(room, `schedules[${dayIndex}].away`, away),
        dayOfWeek: i,
        home1: _.get(room, `schedules[${dayIndex}].home1`, home1),
        home2: _.get(room, `schedules[${dayIndex}].home2`, home2),
        sleep: _.get(room, `schedules[${dayIndex}].sleep`, sleep),
        id: this.state.roomId
      })
      this.setState({ schedules, disabled: false })
    } else {
      schedules.splice(index, 1) // remove exists item from state array (unchecked)
      this.setState({ schedules, disabled: _.size(schedules) > 0 ? false : true })
    }
  }

  onSaveClick() {
    const { location } = this.props
    // Query params is checked when user comes from signup
    const room = queryString.parse(location.search)
    if (room && room.roomId) {
      this.setScheduleCall()
    } else {
      this.setState({ showFirstTime: true })
    }
  }

  setScheduleCall() {
    const { setSchedule } = this.props
    // Save each day schedule from the API
    this.setState({ disabled: true }, () => {
      const schedules = _.first(this.state.schedules)
      setSchedule(schedules)
    })
  }

  closeModal() {
    this.setState({ showFirstTime: false }, () => {
      this.setScheduleCall()
    })
  }

  next() {
    // Does close the modal and redirects back
    this.setState({ copied: false }, () => {
      history.goBack()
    })
  }

  render() {
    const { room } = this.state
    return (
      <div>
        {
          room.schedules ?
          <main id="CopySelectedSchedule">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="secondary-title">Copy Selected Schedule</h3>
                    <div className="close">
                      <a onClick={() => history.goBack()}>
                        <img alt="" src="/img/close-icon.png" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </header>

            <div className="selected-list-box">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <p>Choose the days to which you would like to apply the selected temperature schedule.</p>
                  </div>
                </div>
              </div>
              <ul className="selected-schedule-list list-group">
                {Days.map((day, i) => {
                  return parseInt(this.state.dayOfWeek, 10) === day.value ? (
                    <li key={'li' + i} className="list-group-item d-flex">
                      <label className="check-box">
                        {day.label}
                        <input disabled defaultChecked="true" type="checkbox" onChange={() => this.onClickDayOfWeek(day.value)} />
                        <span className="checkmark checkmark-disabled" />
                      </label>
                    </li>
                  ) : (
                    <li key={'li' + i} className="list-group-item d-flex">
                      <label className="check-box">
                        {day.label}
                        <input type="checkbox" onChange={() => this.onClickDayOfWeek(day.value)} />
                        <span className="checkmark" />
                      </label>
                    </li>
                  )
                })}
              </ul>
            </div>

            <footer>
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      disabled={this.state.disabled}
                      onClick={() => this.onSaveClick()}
                      type="button"
                      className="btn btn-primary btn-lg btn-block"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </footer>
          </div>
          <CommonModal
            key="copyTemperatureSchedule"
            modalType="copyTemperatureSchedule"
            open={this.state.showFirstTime}
            {...this.props}
            closeModal={this.closeModal}
          />
          <CommonModal key="scheduleCopied" modalType="scheduleCopied" open={this.state.copied} {...this.props} closeModal={this.next} />
          </main>
          :
          <div style={{ margin: '40%' }}>Loading...</div>
        }
      </div>
    )
  }
}
export default CopySelectedSchedule


// WEBPACK FOOTER //
// ./src/views/CopySelectedSchedule/component.js